(() => {
  'use strict';
  const root=document.querySelector('[data-dg-lab-tool="double-click"]');
  if(!root) return;
  if(root.dataset['dgLabDoubleClickInitialized'] === 'true') return;
  root.dataset['dgLabDoubleClickInitialized'] = 'true';
  const area=root.querySelector('#area');
  let lastClick=0,clicks=0,doubles=0,intervals=[];
  function get(id){ return root.querySelector('#'+id); }
  area.addEventListener('click',event=>{ if(event.detail===0) return; const now=performance.now(), delta=now-lastClick; clicks++; if(lastClick&&delta<250){ doubles++; intervals.push(delta); } lastClick=now; get('clicks').textContent=clicks; get('double').textContent=doubles; get('interval').textContent=intervals.length?Math.round(intervals.reduce((a,b)=>a+b,0)/intervals.length):'—'; get('state').textContent='Completado'; });
})();
